const posts = [
  { src : "/instgrampost1.jpg", href: "https://www.instagram.com/p/DFSaDMYTjk_/" },
  { src : "/instgrampost2.jpg", href: "https://www.instagram.com/p/DE94tbdCgCP/" },
  { src : "/instgrampost3.jpg", href: "https://www.instagram.com/p/DEpYBLazuvH/" },
  { src : "/instgrampost4.jpg", href: "https://www.instagram.com/p/DEZ1w8LzO4a/" },
  null, // Empty post at index 5
  { src : "/instgrampost5.jpg", href: "https://www.instagram.com/p/DEH19euzq2z/" },
  { src : "/instgrampost6.jpg", href: "https://www.instagram.com/p/DDzPaApi9Vc/" },
  { src : "/instgrampost7.jpg", href: "https://www.instagram.com/p/DDo75OiiSuy/" },
  { src : "/instgrampost8.jpg", href: "https://www.instagram.com/p/DB6P3jxz8UX/" },
];

const InstagramPost = () => {
  return (
    <>
      <div className="instagram-posts-title">Instagram Posts</div>
      <div className="instagram-posts-container">
        {posts.map((post, index) =>
          post ? (
            <a
              key={index}
              href={post.href}
              target="_blank"
              rel="noopener noreferrer"
              className="instagram-post"
            >
              <img src={post.src} alt="instagram-icon" loading="lazy" />
            </a>
          ) : (
            <div key={index} className="instagram-post empty">
              <img src="/icon-instagram.svg" alt="instagram-icon" loading="lazy" />
            </div>
          )
        )}
      </div>
    </>
  );
};

export default InstagramPost;